export const ratingsFrag = `
    id
    waitingListId    
    date
    rating
    totalPoints
`;

export const updateWaitingListItemFrag = `
    id
`;

export const prevContractsFrag = `
    id
    formField
    formAmbulant
    formResidental
`;
